// extracted by mini-css-extract-plugin
export default {"main_container":"Article1_main_container__DroAx","images":"Article1_images__+syI7","button54":"Article1_button54__eZzVG","button":"Article1_button__Jbqj5"};